import React from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import { useLocation, useNavigate } from "react-router-dom";
import NavbarClickLocationSearch from "../components/layouts/functions/Navbar.ClickLocationSearch";
import { ContextLanguage } from "../context/Context.Language";
import { TEXT_ADDRESS_SEARCH } from "./useConstants";
import { STATE_CONSTANTS_ADDRESS } from "./useConstantState";
import {
  StoreIsShowAnotherValue,
  StoreSelectedLocation,
  StoreTabAddress,
  SystemStoreBasketAddress,
} from "./useStorage";
import {
  STYLE_LOCATION_NAVBAR_PLACEHOLDER,
  STYLE_LOCATION_NAVBAR_PLACEHOLDER_LOCATION,
  STYLE_TITLE_MEDIUM,
} from "./useStyle";

export const isBrowser = typeof window !== "undefined" && window.document;

const googleMapsKey = "AIzaSyCBkCqnxwMUmT33843_vgeP1IXhxT1EVGE";

export const GOOGLE_MAP_SCRIPT_BASE_URL =
  "https://maps.googleapis.com/maps/api/js";

const libraries = "places";

export const loadGoogleMapScript = (
  googleMapsScriptBaseUrl,
  googleMapsScriptUrl
) => {
  if (!isBrowser) return Promise.resolve();

  const google = window.google || {};

  if (typeof google !== "undefined") {
    if (google.maps && google.maps.api) return Promise.resolve();
  }

  const scriptElements = document.querySelectorAll(
    `script[src*="${googleMapsScriptBaseUrl}"]`
  );

  if (scriptElements && scriptElements.length) {
    return new Promise((resolve) => {
      // in case we already have a script on the page and it's loaded we resolve
      if (typeof google !== "undefined") return resolve();

      // otherwise we wait until it's loaded and resolve
      scriptElements[0].addEventListener("load", () => resolve());
    });
  }

  let scriptUrl = new URL(googleMapsScriptUrl);
  scriptUrl.searchParams.set(
    "callback",
    "__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__"
  );
  const el = document.createElement("script");
  el.src = scriptUrl.toString();

  return new Promise((resolve) => {
    window.__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__ = resolve;
    document.body.appendChild(el);
  });
};

export const FunctionSearchLocation = ({ isNotCompleteProfile = true }) => {
  // const [loaded, setLoaded] = React.useState(false);
  const [search, setSearch] = React.useState("");
  // const google = window.google || {};

  const lopath = useLocation();
  const navigate = useNavigate();

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const { language } = React.useContext(ContextLanguage);

  const setTab = StoreTabAddress((state) => state.setTab);
  const tab = StoreTabAddress((state) => state.tab);
  const address = SystemStoreBasketAddress((state) => state.address);

  // const setIsShowAnother = StoreIsShowAnotherValue(
  //   (state) => state.setIsShowAnother
  // );

  // const autocompleteRef = React.useRef(null);
  // const inputRef = React.useRef(null);
  // const observerHack = React.useRef(null);

  // const event = React.useRef(null);

  // const googleMapsScriptBaseUrl = GOOGLE_MAP_SCRIPT_BASE_URL;

  // const googleMapsScriptUrl = `https://maps.googleapis.com/maps/api/place/autocomplete/json??key=${googleMapsKey}&language=th,en&components=country:th`;

  // const handleLoadScript = React.useCallback(
  //   () => loadGoogleMapScript(googleMapsScriptBaseUrl, googleMapsScriptUrl),
  //   [googleMapsScriptBaseUrl, googleMapsScriptUrl]
  // );

  const onPlaceSelected = (a) => {
    const completeProfilePage = window.location.pathname === "/CompleteProfile";

    if (!completeProfilePage) {
      let thisValue = {
        ...a,
      };

      if (thisValue?.geometry?.location?.lat()) {
        thisValue = {
          ...thisValue,
          lat: thisValue.geometry.location.lat(),
          lng: thisValue.geometry.location.lng(),
        };

        setSelectedLocation({
          lat: "-62.7720728",
          lng: "-65.977308,721794",
          isAvilable: false,
          name: "Loading...",
        });

        NavbarClickLocationSearch({
          isPageAddress: lopath.pathname === "/Address",
          tab,
          setTab,
          setSelectedLocation,
          setValue: setSearch,
          locationValue: a,
          navigate,
        });
        if (ref.current) {
          ref.current.blur();
        }
      } else {
        //   setIsShowAnother(true);
        //   setTab(STATE_CONSTANTS_ADDRESS.SEARCH);
        //   setSelectedLocation(false);
        //   navigate("/Address");
      }
    } else {
      return;
    }
    // console.log("RES :", {
    //   a,
    //   b,
    //   c,
    // });
  };

  const { ref } = usePlacesWidget({
    apiKey: "AIzaSyCBkCqnxwMUmT33843_vgeP1IXhxT1EVGE",
    onPlaceSelected: (a) => onPlaceSelected(a),
    options: {
      types: ["establishment"],
      fields: [
        "address_components",
        "geometry",
        "place_id",
        "formatted_address",
        "name",
      ],
      componentRestrictions: { country: "th" },
    },
    inputAutocompleteValue: search,
  });

  React.useEffect(() => {
    window.addEventListener("scroll", () => {
      if (ref.current) {
        ref.current.blur();
      }
    });
  }, []);

  // console.log("LOADED :", {
  //   autocompleteRef,
  //   inputRef,
  // });

  // const config = {
  //   types: ["establishment"],
  //   fields: [
  //     "address_components",
  //     "geometry",
  //     "place_id",
  //     "formatted_address",
  //     "name",
  //   ],
  //   componentRestrictions: { country: "th" },
  //   //   ...options,
  //   //   fields,
  //   //   types,
  //   //   bounds,
  // };

  // React.useEffect(() => {
  //   if (autocompleteRef.current || !inputRef.current || !isBrowser) return;

  //   const handleAutoComplete = () => {
  //     autocompleteRef.current = new google.maps.places.Autocomplete(
  //       inputRef.current,
  //       config
  //     );

  //     if (autocompleteRef.current) {
  //       event.current = autocompleteRef.current.addListener(
  //         "place_changed",
  //         () => {
  //           if (onPlaceSelected && autocompleteRef && autocompleteRef.current) {
  //             onPlaceSelected(
  //               autocompleteRef.current.getPlace(),
  //               inputRef.current,
  //               autocompleteRef.current
  //             );
  //           }
  //         }
  //       );
  //     }

  //     //on enter

  //     //   inputRef.current.addEventListener("keydown", (e) => {
  //     //     if (e.key === "Enter") {
  //     //       e.preventDefault();
  //     //       e.stopPropagation();

  //     //       if (autocompleteRef && autocompleteRef.current) {
  //     //         onPlaceSelected(
  //     //           autocompleteRef.current.getPlace(),
  //     //           inputRef.current,
  //     //           autocompleteRef.current
  //     //         );
  //     //       }
  //     //     }
  //     //   });
  //   };

  //   handleLoadScript().then(() => handleAutoComplete());

  //   return () => (event.current ? event.current.remove() : undefined);
  // }, [loaded, isNotCompleteProfile]);

  // React.useEffect(() => {
  //   if (isBrowser) {
  //     //   let addressInputElement = document.querySelector(
  //     //     "#address-dropdown-input"
  //     //   );

  //     //   addressInputElement.addEventListener("focus", function () {
  //     //   let pacContainer = document.querySelector(".pac-container");

  //     //   console.log("NODE", pacContainer);

  //     //   if (pacContainer?.length > 0) {
  //     //     console.log("CLONE");
  //     //     const clone = pacContainer[0].cloneNode(true);
  //     //     addressInputElement.parentNode.appendChild(clone);
  //     //   }
  //     //   });

  //     //   console.log("addressInputElement", addressInputElement);

  //     observerHack.current = new MutationObserver(() => {
  //       observerHack.current.disconnect();

  //       if (inputRef.current) {
  //         inputRef.current.autocomplete = search;
  //       }
  //     });
  //     observerHack.current.observe(inputRef.current, {
  //       attributes: true,
  //       attributeFilter: ["autocomplete"],
  //     });
  //   }
  // }, [search]);

  return (
    <div className="flex justify-between w-full relative ">
      <input
        placeholder={address?.name ?? TEXT_ADDRESS_SEARCH[language]}
        className={`${STYLE_LOCATION_NAVBAR_PLACEHOLDER_LOCATION("EN")}  ${
          address?.name
            ? " placeholder:text-laudry-gray-200 "
            : " placeholder:text-laundry-gray-50 "
        } ${STYLE_TITLE_MEDIUM}  font-Poppins text-base `}
        ref={ref}
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
    </div>
  );
};
